import SessionService from './SessionService';

export default class PlanService {

    static getPlan() {
        const data = SessionService.getData();
        return data?.plan || null;
    }

    static getModules() {
        return this.getPlan()?.modules || {};
    }

    static hasModule(moduleKey) {
        const modules = this.getModules();
        return modules[moduleKey] === true;
    }

    static hasAnyModule(prefix) {
        const modules = this.getModules();
        return Object.keys(modules).some(k => k.startsWith(prefix) && modules[k] === true);
    }
}
